// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"515":"874493cd","688":"c216955b"}[chunkId] + ".chunk.js";
};